import { VStack } from "@chakra-ui/react";
import { ICcbVinculoAtivo } from "@/models/consignado/proposal-billings.model";
import ContatosSection from "./ContatosSection";
import NegociacaoSection from "./NegociacaoSection";
import NovosVinculosSection from "./NovosVinculosSection";
import ResumoFinanceiroSection from "./ResumoFinanceiroSection";
import HistoricoNotificacoesSection from "./HistoricoNotificacoesSection";
import SinistroSection from "./SinistroSection";

type Props = {
  ccb: ICcbVinculoAtivo;
};

// Nível 3 do redesign. Cada seção tem query própria por número da CCB e faz o
// próprio lazy-load (nasce colapsada, dispara na 1ª abertura); só o Resumo
// Financeiro já vem aberto. Todas REAIS: Resumo financeiro + parcelas,
// Novos Vínculos, Negociação (HIS-024), Sinistro (HIS-030), Dados de Contato
// (HIS-024) e Histórico de notificações (TAR-050). As que usam rotas por UUID
// da cobrança (Novos Vínculos, Negociação, Sinistro) recebem `ccb.cobranca_id`
// e pegam o detalhe por useCobrancaDetalhe quando precisam. Novos Vínculos e
// Sinistro só aparecem quando a listagem trouxe `termino_vinculo`. O CcbRow
// desmonta este componente ao colapsar a linha, então o estado zera sozinho.
export default function CcbDetalhe({ ccb }: Props) {
  return (
    <VStack spacing={4} align="stretch">
      <ResumoFinanceiroSection numeroCcb={ccb.numero_ccb} />

      {ccb.termino_vinculo && (
        <NovosVinculosSection cobrancaId={ccb.cobranca_id} tomadorDocumento={ccb.tomador_documento} />
      )}

      <NegociacaoSection numeroCcb={ccb.numero_ccb} cobrancaId={ccb.cobranca_id} />

      {ccb.termino_vinculo && <SinistroSection cobrancaId={ccb.cobranca_id} />}

      <ContatosSection numeroCcb={ccb.numero_ccb} />

      <HistoricoNotificacoesSection numeroCcb={ccb.numero_ccb} />
    </VStack>
  );
}
